module.exports = __webpack_public_path__ + "static/brecha-digital-cb4a2c6ab0064e9eeacb91806162476a.png";